import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const Container = styled(FlexBox)`
    width: 100%;
    height: 100%;
    justify-content: center;
    place-items: center;
    flex-flow: column;
    // background-color: #fff;
    // opacity: 0.7;
    // -webkit-filter: blur(4px);
    // -moz-filter: blur(4px);
    // -o-filter: blur(4px);
    // -ms-filter: blur(4px);
    // filter: blur(4px);

    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

`;

export const Title = styled.h5`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    padding: 0 16px;
    text-align: center;

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const Subtitle = styled.h6`
    font-family: 'Inter';
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    padding: 0 16px;
    text-align: center;

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const StopHolder: FC = () => {
    const { t } = useTranslation();
    return (
        <Container gy={4} gyMobile={4}>
            <Title>{t('subscription.stopped_subscribe_title')}</Title>
            <Subtitle>{t('subscription.stopped_subscribe_subtitle')}</Subtitle>
        </Container>
    )
}

export const HiddenHolder: FC = () => {
    const { t } = useTranslation();
    return (
        <Container gy={4} gyMobile={4}>
            <Title>{t('subscription.hidden_subscribe_title')}</Title>
            <Subtitle>{t('subscription.hidden_subscribe_subtitle')}</Subtitle>
        </Container>
    )
}

export default {
    StopHolder,
    HiddenHolder
}import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const Container = styled(FlexBox)`
    width: 100%;
    height: 100%;
    justify-content: center;
    place-items: center;
    flex-flow: column;
    // background-color: #fff;
    // opacity: 0.7;
    // -webkit-filter: blur(4px);
    // -moz-filter: blur(4px);
    // -o-filter: blur(4px);
    // -ms-filter: blur(4px);
    // filter: blur(4px);

    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

`;

export const Title = styled.h5`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    padding: 0 16px;
    text-align: center;

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const Subtitle = styled.h6`
    font-family: 'Inter';
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    padding: 0 16px;
    text-align: center;

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const StopHolder: FC = () => {
    const { t } = useTranslation();
    return (
        <Container gy={4} gyMobile={4}>
            <Title>{t('subscription.stopped_subscribe_title')}</Title>
            <Subtitle>{t('subscription.stopped_subscribe_subtitle')}</Subtitle>
        </Container>
    )
}

export const HiddenHolder: FC = () => {
    const { t } = useTranslation();
    return (
        <Container gy={4} gyMobile={4}>
            <Title>{t('subscription.hidden_subscribe_title')}</Title>
            <Subtitle>{t('subscription.hidden_subscribe_subtitle')}</Subtitle>
        </Container>
    )
}

export default {
    StopHolder,
    HiddenHolder
}